//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SchoolMileageSettingsUpdateItem } from './SchoolMileageSettingsUpdateItem';
import { SchoolLatePaymentFeeSettingsUpdateItem } from './SchoolLatePaymentFeeSettingsUpdateItem';
import { BalanceDateType, SurchargeType } from './Enums';

export class SchoolAccountingSettingsUpdateItem extends ItemBase {
    DefaultBalanceDateType?: BalanceDateType;
    DefaultBalanceDateDayOfMonth?: number;
    DefaultMileageSettings?: SchoolMileageSettingsUpdateItem | null;
    LateFeeEventCategoryID?: string | null;
    LatePaymentFeeSettings?: SchoolLatePaymentFeeSettingsUpdateItem | null;
    LatePaymentFeeType?: SurchargeType;
    MembershipFeeCategoryID?: string | null;
    PaymentMethods?: string[];
    SpecifiedBalanceDate?: string;

    constructor(initializer?: Partial<SchoolAccountingSettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolAccountingSettingsUpdateItem";
}
